"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var filter_type_1 = require("../filter/type/filter-type");
var filter_dto_builder_1 = require("../filter/builder/filter-dto-builder");
var abstract_category_filter_dto_1 = require("../filter/dto/abstract-category-filter-dto");
var abstract_measure_filter_dto_1 = require("../filter/dto/abstract-measure-filter-dto");
var contains_filter_dto_1 = require("../filter/dto/contains-filter-dto");
var exact_filter_dto_1 = require("../filter/dto/exact-filter-dto");
var filter_dto_1 = require("../filter/dto/filter-dto");
var starts_with_filter_dto_1 = require("../filter/dto/starts-with-filter-dto");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var category_item_dto_1 = require("../item/dto/category-item-dto");
var category_type_1 = require("../item/type/category-type");
var date_category_type_1 = require("../item/type/date-category-type");
var measure_item_dto_1 = require("../item/dto/measure-item-dto");
var measure_type_1 = require("../item/type/measure-type");
var filter_item_1 = require("../filter/filter-item");
var criterion_into_dto_1 = require("../visitor/criterion-into-dto");
var filter_type_negations_1 = require("../filter/type/filter-type-negations");
var criterion_validator_1 = require("../visitor/criterion-validator");
var criterion_numbers_1 = require("../criterion/criterion-numbers");
var category_criterion_number_1 = require("../criterion/category-criterion-number");
var criterion_string_1 = require("../criterion/criterion-string");
var criterion_number_1 = require("../criterion/criterion-number");
var criterion_date_range_1 = require("../criterion/criterion-date-range");
var criterion_number_range_1 = require("../criterion/criterion-number-range");
var range_bounding_1 = require("../criterion/range-bounding");
var measure_criterion_number_1 = require("../criterion/measure-criterion-number");
var measure_criterion_number_range_1 = require("../criterion/measure-criterion-number-range");
var criterion_date_1 = require("../criterion/criterion-date");
var measure_criterion_money_1 = require("../criterion/measure-criterion-money");
var measure_criterion_money_range_1 = require("../criterion/measure-criterion-money-range");
var criterion_helper_1 = require("./criterion-helper");
var FilterHelper = /** @class */ (function () {
    function FilterHelper() {
    }
    FilterHelper.filterGroupsToDTO = function (filterGroups) {
        var overallResult = filter_dto_builder_1.FilterDtoBuilder.createOrFilterBuilder().build();
        var isFirstGroup = true;
        filterGroups.forEach(function (filterGroup) {
            if (filterGroup.isTemporary()) {
                return;
            }
            var groupResult;
            var groupBuilder = filter_dto_builder_1.FilterDtoBuilder.createAndFilterBuilder();
            var expressionTail = null;
            filterGroup.filterItems.forEach(function (filterItem) {
                if (filterItem.isTemporary()) {
                    return;
                }
                var appender = new criterion_into_dto_1.CriterionIntoDTO(filterItem, groupBuilder, expressionTail);
                filterItem.criterion.accept(appender);
            });
            groupResult = groupBuilder.build();
            if (isFirstGroup) {
                isFirstGroup = false;
                overallResult = groupResult;
            }
            else {
                overallResult = filter_dto_builder_1.FilterDtoBuilder.combineOr(overallResult, groupResult);
            }
        });
        return overallResult;
    };
    FilterHelper.isNegatingFromDTO = function (filterElement) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(filterElement);
        return filterElement.excluded;
    };
    FilterHelper.itemFromDTO = function (filterElement, items) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(filterElement);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(items);
        var result = null;
        if (filterElement instanceof abstract_category_filter_dto_1.AbstractCategoryFilterDto) {
            result = items.get(filterElement.onCategoryItemId);
        }
        else if (filterElement instanceof abstract_measure_filter_dto_1.AbstractMeasureFilterDto) {
            result = items.get(filterElement.onMeasureItemId);
        }
        else if (filterElement instanceof filter_dto_1.FilterDto) {
            if (filterElement instanceof contains_filter_dto_1.ContainsFilterDto) {
                result = items.get(filterElement.itemId);
            }
            else if (filterElement instanceof starts_with_filter_dto_1.StartsWithFilterDto) {
                result = items.get(filterElement.itemId);
            }
        }
        return result;
    };
    FilterHelper.filterTypeFromDTO = function (filterElement) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(filterElement);
        var result = null;
        var filterType = filterElement.filterType;
        var isNot = FilterHelper.isNegatingFromDTO(filterElement);
        if (filterType === filter_dto_builder_1.FilterDtoBuilder.BETWEEN_DATES) {
            result = isNot ? filter_type_1.FilterType.NOT_BETWEEN : filter_type_1.FilterType.BETWEEN;
        }
        else if (filterType === filter_dto_builder_1.FilterDtoBuilder.ON_OR_BEFORE) {
            result = filter_type_1.FilterType.ON_OR_BEFORE;
        }
        else if (filterType === filter_dto_builder_1.FilterDtoBuilder.ON_OR_AFTER) {
            result = filter_type_1.FilterType.ON_OR_AFTER;
        }
        else if (filterType === filter_dto_builder_1.FilterDtoBuilder.IN) {
            result = isNot ? filter_type_1.FilterType.NOT_AMONG : filter_type_1.FilterType.AMONG;
        }
        else if (filterType === filter_dto_builder_1.FilterDtoBuilder.UNSPECIFIED) {
            result = isNot ? filter_type_1.FilterType.SPECIFIED : filter_type_1.FilterType.UNSPECIFIED;
        }
        else if (filterType === filter_dto_builder_1.FilterDtoBuilder.IS) {
            result = isNot ? filter_type_1.FilterType.IS_NOT : filter_type_1.FilterType.IS;
        }
        else if (filterType === filter_dto_builder_1.FilterDtoBuilder.IS_CURRENT) {
            result = isNot ? filter_type_1.FilterType.NOT_CURRENT : filter_type_1.FilterType.CURRENT;
        }
        else if (filterType === filter_dto_builder_1.FilterDtoBuilder.IS_LAST) {
            result = filter_type_1.FilterType.PREVIOUS;
        }
        else if (filterType === filter_dto_builder_1.FilterDtoBuilder.IS_NEXT) {
            result = filter_type_1.FilterType.NEXT;
        }
        else if (filterType === filter_dto_builder_1.FilterDtoBuilder.TOP) {
            result = filter_type_1.FilterType.TOP;
        }
        else if (filterType === contains_filter_dto_1.ContainsFilterDto.CONTAINS) {
            result = isNot ? filter_type_1.FilterType.NOT_CONTAINS : filter_type_1.FilterType.CONTAINS;
        }
        else if (filterType === starts_with_filter_dto_1.StartsWithFilterDto.STARTS_WITH) {
            result = filter_type_1.FilterType.BEGINS_WITH;
        }
        else if (filterType === exact_filter_dto_1.ExactFilterDto.EXACT) {
            result = isNot ? filter_type_1.FilterType.NOT_EQUALS : filter_type_1.FilterType.EQUALS;
        }
        else if (filterType === filter_dto_builder_1.FilterDtoBuilder.BETWEEN) {
            result = isNot ? filter_type_1.FilterType.NOT_BETWEEN : filter_type_1.FilterType.BETWEEN;
        }
        else if (filterType === filter_dto_builder_1.FilterDtoBuilder.LESS_THAN) {
            result = filter_type_1.FilterType.LESS_THAN;
        }
        else if (filterType === filter_dto_builder_1.FilterDtoBuilder.LESS_THAN_OR_EQUAL) {
            result = filter_type_1.FilterType.LESS_THAN_OR_EQUALS;
        }
        else if (filterType === filter_dto_builder_1.FilterDtoBuilder.GREATER_THAN) {
            result = filter_type_1.FilterType.GREATER_THAN;
        }
        else if (filterType === filter_dto_builder_1.FilterDtoBuilder.GREATER_THAN_OR_EQUAL) {
            result = filter_type_1.FilterType.GREATER_THAN_OR_EQUALS;
        }
        else if (filterType === filter_dto_builder_1.FilterDtoBuilder.IS_CURRENT_USER) {
            result = filter_type_1.FilterType.CURRENT_USER;
        }
        return result;
    };
    FilterHelper.filterItemFromDTO = function (filterComponent, filterElement) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(filterComponent);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(filterElement);
        var filterItem = null;
        var criterionValidator = new criterion_validator_1.CriterionValidator();
        var item = FilterHelper.itemFromDTO(filterElement, filterComponent.items);
        var filterType = FilterHelper.filterTypeFromDTO(filterElement);
        if (!item) {
            return filterItem;
        }
        else if (!filterType) {
            throw new Error("Unhandled filter type (was '" + filterElement.filterType + "').");
        }
        filterItem = new filter_item_1.FilterItem(filterComponent, criterionValidator, item, filterType);
        filterItem.criterion = FilterHelper.criterionFor(filterItem, filterElement);
        return filterItem;
    };
    FilterHelper.criterionFor = function (filterItem, filterElement) {
        if (filterElement === void 0) { filterElement = null; }
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(filterItem);
        idm_common_util_frontend_1.PreconditionCheck.notUndefined(filterElement);
        var criterion = null;
        var item = filterItem.item;
        var filterType = filterItem.filterType;
        var isNot = filter_type_negations_1.FilterTypeNegations.isNegating(filterType);
        if (item instanceof category_item_dto_1.CategoryItemDto) {
            var categoryType = item.categoryType;
            var dateCategoryType = item.dateCategoryType;
            if (categoryType === category_type_1.CategoryType.STANDARD) {
                if (filterType === filter_type_1.FilterType.AMONG || filterType === filter_type_1.FilterType.NOT_AMONG) {
                    var values = filterElement ? filterElement.values : [];
                    criterion = new criterion_numbers_1.CriterionNumbers(filterItem, isNot, values);
                }
                else if (filterType === filter_type_1.FilterType.SPECIFIED || filterType === filter_type_1.FilterType.UNSPECIFIED) {
                    var values = [null];
                    criterion = new criterion_numbers_1.CriterionNumbers(filterItem, isNot, values);
                }
                else if (filterType === filter_type_1.FilterType.TOP) {
                    var value = filterElement ? filterElement.topCount : null;
                    var byMeasureItemId = filterElement ? filterElement.byMeasureItemId : null;
                    criterion = new category_criterion_number_1.CategoryCriterionNumber(filterItem, isNot, value, byMeasureItemId);
                }
                else if (filterType === filter_type_1.FilterType.CONTAINS || filterType === filter_type_1.FilterType.NOT_CONTAINS) {
                    var value = filterElement ? filterElement.value : null;
                    criterion = new criterion_string_1.CriterionString(filterItem, isNot, value);
                }
                else if (filterType === filter_type_1.FilterType.BEGINS_WITH) {
                    var value = filterElement ? filterElement.value : null;
                    criterion = new criterion_string_1.CriterionString(filterItem, isNot, value);
                }
            }
            else if (categoryType === category_type_1.CategoryType.ME_ASSETS) {
                if (filterType === filter_type_1.FilterType.AMONG || filterType === filter_type_1.FilterType.NOT_AMONG) {
                    var values = filterElement ? filterElement.values : [];
                    criterion = new criterion_numbers_1.CriterionNumbers(filterItem, isNot, values);
                }
                else if (filterType === filter_type_1.FilterType.SPECIFIED || filterType === filter_type_1.FilterType.UNSPECIFIED) {
                    var values = [null];
                    criterion = new criterion_numbers_1.CriterionNumbers(filterItem, isNot, values);
                }
            }
            else if (categoryType === category_type_1.CategoryType.DATE) {
                if (filterType === filter_type_1.FilterType.AMONG || filterType === filter_type_1.FilterType.NOT_AMONG) {
                    var values = filterElement ? filterElement.values : [];
                    if (dateCategoryType === date_category_type_1.DateCategoryType.DAY) {
                        throw new Error('Not implemented!');
                    }
                    else {
                        criterion = new criterion_numbers_1.CriterionNumbers(filterItem, isNot, values);
                    }
                }
                else if (filterType === filter_type_1.FilterType.IS || filterType === filter_type_1.FilterType.IS_NOT) {
                    var value = filterElement ? filterElement.value : null;
                    if (dateCategoryType === date_category_type_1.DateCategoryType.DAY) {
                        criterion = new criterion_date_1.CriterionDate(filterItem, isNot, criterion_helper_1.CriterionHelper.ifDate(value));
                    }
                    else {
                        throw new Error('Not implemented!');
                    }
                }
                else if (filterType === filter_type_1.FilterType.SPECIFIED || filterType === filter_type_1.FilterType.UNSPECIFIED) {
                    var values = [null];
                    criterion = new criterion_numbers_1.CriterionNumbers(filterItem, isNot, values);
                }
                else if (filterType === filter_type_1.FilterType.CURRENT || filterType === filter_type_1.FilterType.NOT_CURRENT) {
                    var value = 0;
                    criterion = new criterion_number_1.CriterionNumber(filterItem, isNot, value);
                }
                else if (filterType === filter_type_1.FilterType.PREVIOUS) {
                    var value = filterElement ? filterElement.value : null;
                    criterion = new criterion_number_1.CriterionNumber(filterItem, isNot, value);
                }
                else if (filterType === filter_type_1.FilterType.NEXT) {
                    var value = filterElement ? filterElement.value : null;
                    criterion = new criterion_number_1.CriterionNumber(filterItem, isNot, value);
                }
                else if (filterType === filter_type_1.FilterType.BETWEEN || filterType === filter_type_1.FilterType.NOT_BETWEEN) {
                    var valueFrom = filterElement ? filterElement.valueFrom : null;
                    var valueTo = filterElement ? filterElement.valueTo : null;
                    if (dateCategoryType === date_category_type_1.DateCategoryType.DAY) {
                        criterion = new criterion_date_range_1.CriterionDateRange(filterItem, isNot, true, null, criterion_helper_1.CriterionHelper.ifDate(valueFrom), criterion_helper_1.CriterionHelper.ifDate(valueTo));
                    }
                    else {
                        criterion = new criterion_number_range_1.CriterionNumberRange(filterItem, isNot, true, null, criterion_helper_1.CriterionHelper.ifNumber(valueFrom), criterion_helper_1.CriterionHelper.ifNumber(valueTo));
                    }
                }
                else if (filterType === filter_type_1.FilterType.ON_OR_BEFORE) {
                    var valueTo = filterElement ? filterElement.valueTo : null;
                    if (dateCategoryType === date_category_type_1.DateCategoryType.DAY) {
                        criterion = new criterion_date_range_1.CriterionDateRange(filterItem, isNot, true, range_bounding_1.RangeBounding.UPPER, null, criterion_helper_1.CriterionHelper.ifDate(valueTo));
                    }
                    else {
                        criterion = new criterion_number_range_1.CriterionNumberRange(filterItem, isNot, true, range_bounding_1.RangeBounding.UPPER, null, criterion_helper_1.CriterionHelper.ifNumber(valueTo));
                    }
                }
                else if (filterType === filter_type_1.FilterType.ON_OR_AFTER) {
                    var valueFrom = filterElement ? filterElement.valueFrom : null;
                    if (dateCategoryType === date_category_type_1.DateCategoryType.DAY) {
                        criterion = new criterion_date_range_1.CriterionDateRange(filterItem, isNot, true, range_bounding_1.RangeBounding.LOWER, criterion_helper_1.CriterionHelper.ifDate(valueFrom), null);
                    }
                    else {
                        criterion = new criterion_number_range_1.CriterionNumberRange(filterItem, isNot, true, range_bounding_1.RangeBounding.LOWER, criterion_helper_1.CriterionHelper.ifNumber(valueFrom), null);
                    }
                }
            }
            else if (categoryType === category_type_1.CategoryType.USER) {
                if (filterType === filter_type_1.FilterType.AMONG || filterType === filter_type_1.FilterType.NOT_AMONG) {
                    var values = filterElement ? filterElement.values : [];
                    criterion = new criterion_numbers_1.CriterionNumbers(filterItem, isNot, values);
                }
                else if (filterType === filter_type_1.FilterType.SPECIFIED || filterType === filter_type_1.FilterType.UNSPECIFIED) {
                    var values = [null];
                    criterion = new criterion_numbers_1.CriterionNumbers(filterItem, isNot, values);
                }
                else if (filterType === filter_type_1.FilterType.CURRENT_USER) {
                    var value = 0;
                    criterion = new criterion_number_1.CriterionNumber(filterItem, isNot, value);
                }
            }
            if (!criterion) {
                throw new Error("Unhandled combination of category and filter types (were '" + category_type_1.CategoryType[filterType] + "' and '" + filter_type_1.FilterType[filterType] + "' respectively).");
            }
        }
        else if (item instanceof measure_item_dto_1.MeasureItemDto) {
            var measureType = item.measureType;
            var byCategoryItemId = filterElement ? filterElement.byCategoryItemId : null;
            if (measureType === measure_type_1.MeasureType.NUMBER) {
                if (filterType === filter_type_1.FilterType.EQUALS || filterType === filter_type_1.FilterType.NOT_EQUALS) {
                    var value = filterElement ? filterElement.value : null;
                    criterion = new measure_criterion_number_1.MeasureCriterionNumber(filterItem, isNot, criterion_helper_1.CriterionHelper.ifNumber(value), byCategoryItemId);
                }
                else if (filterType === filter_type_1.FilterType.BETWEEN || filterType === filter_type_1.FilterType.NOT_BETWEEN) {
                    var valueFrom = filterElement ? filterElement.valueFrom : null;
                    var valueTo = filterElement ? filterElement.valueTo : null;
                    criterion = new measure_criterion_number_range_1.MeasureCriterionNumberRange(filterItem, isNot, true, null, criterion_helper_1.CriterionHelper.ifNumber(valueFrom), criterion_helper_1.CriterionHelper.ifNumber(valueTo), byCategoryItemId);
                }
                else if (filterType === filter_type_1.FilterType.LESS_THAN) {
                    var valueTo = filterElement ? filterElement.valueTo : null;
                    criterion = new measure_criterion_number_range_1.MeasureCriterionNumberRange(filterItem, isNot, false, range_bounding_1.RangeBounding.UPPER, null, criterion_helper_1.CriterionHelper.ifNumber(valueTo), byCategoryItemId);
                }
                else if (filterType === filter_type_1.FilterType.LESS_THAN_OR_EQUALS) {
                    var valueTo = filterElement ? filterElement.valueTo : null;
                    criterion = new measure_criterion_number_range_1.MeasureCriterionNumberRange(filterItem, isNot, true, range_bounding_1.RangeBounding.UPPER, null, criterion_helper_1.CriterionHelper.ifNumber(valueTo), byCategoryItemId);
                }
                else if (filterType === filter_type_1.FilterType.GREATER_THAN) {
                    var valueFrom = filterElement ? filterElement.valueFrom : null;
                    criterion = new measure_criterion_number_range_1.MeasureCriterionNumberRange(filterItem, isNot, false, range_bounding_1.RangeBounding.LOWER, criterion_helper_1.CriterionHelper.ifNumber(valueFrom), null, byCategoryItemId);
                }
                else if (filterType === filter_type_1.FilterType.GREATER_THAN_OR_EQUALS) {
                    var valueFrom = filterElement ? filterElement.valueFrom : null;
                    criterion = new measure_criterion_number_range_1.MeasureCriterionNumberRange(filterItem, isNot, true, range_bounding_1.RangeBounding.LOWER, criterion_helper_1.CriterionHelper.ifNumber(valueFrom), null, byCategoryItemId);
                }
            }
            else if (measureType === measure_type_1.MeasureType.DATE) {
                if (filterType === filter_type_1.FilterType.EQUALS || filterType === filter_type_1.FilterType.NOT_EQUALS) {
                    var value = filterElement ? filterElement.value : null;
                    criterion = new criterion_date_1.CriterionDate(filterItem, isNot, criterion_helper_1.CriterionHelper.ifDate(value));
                }
                else if (filterType === filter_type_1.FilterType.EMPTY) {
                    throw new Error('Not implemented!');
                }
                else if (filterType === filter_type_1.FilterType.TODAY) {
                    throw new Error('Not implemented!');
                }
                else if (filterType === filter_type_1.FilterType.BETWEEN || filterType === filter_type_1.FilterType.NOT_BETWEEN) {
                    var valueFrom = filterElement ? filterElement.valueFrom : null;
                    var valueTo = filterElement ? filterElement.valueTo : null;
                    criterion = new criterion_date_range_1.CriterionDateRange(filterItem, isNot, true, null, criterion_helper_1.CriterionHelper.ifDate(valueFrom), criterion_helper_1.CriterionHelper.ifDate(valueTo));
                }
                else if (filterType === filter_type_1.FilterType.ON_OR_BEFORE) {
                    var valueTo = filterElement ? filterElement.valueTo : null;
                    criterion = new criterion_date_range_1.CriterionDateRange(filterItem, isNot, true, range_bounding_1.RangeBounding.UPPER, null, criterion_helper_1.CriterionHelper.ifDate(valueTo));
                }
                else if (filterType === filter_type_1.FilterType.ON_OR_AFTER) {
                    var valueFrom = filterElement ? filterElement.valueFrom : null;
                    criterion = new criterion_date_range_1.CriterionDateRange(filterItem, isNot, true, range_bounding_1.RangeBounding.LOWER, criterion_helper_1.CriterionHelper.ifDate(valueFrom), null);
                }
            }
            else if (measureType === measure_type_1.MeasureType.TEXT) {
                if (filterType === filter_type_1.FilterType.CONTAINS || filterType === filter_type_1.FilterType.NOT_CONTAINS) {
                    var value = filterElement ? filterElement.value : null;
                    criterion = new criterion_string_1.CriterionString(filterItem, isNot, value);
                }
                else if (filterType === filter_type_1.FilterType.BEGINS_WITH) {
                    var value = filterElement ? filterElement.value : null;
                    criterion = new criterion_string_1.CriterionString(filterItem, isNot, value);
                }
            }
            else if (measureType === measure_type_1.MeasureType.MONEY) {
                var currencyId = filterElement ? filterElement.currencyId : filterItem.parent.defaultCurrencyID;
                if (filterType === filter_type_1.FilterType.EQUALS || filterType === filter_type_1.FilterType.NOT_EQUALS) {
                    var value = filterElement ? filterElement.value : null;
                    criterion = new measure_criterion_money_1.MeasureCriterionMoney(filterItem, isNot, criterion_helper_1.CriterionHelper.ifNumber(value), byCategoryItemId, currencyId);
                }
                else if (filterType === filter_type_1.FilterType.BETWEEN || filterType === filter_type_1.FilterType.NOT_BETWEEN) {
                    var valueFrom = filterElement ? filterElement.valueFrom : null;
                    var valueTo = filterElement ? filterElement.valueTo : null;
                    criterion = new measure_criterion_money_range_1.MeasureCriterionMoneyRange(filterItem, isNot, true, null, criterion_helper_1.CriterionHelper.ifNumber(valueFrom), criterion_helper_1.CriterionHelper.ifNumber(valueTo), byCategoryItemId, currencyId);
                }
                else if (filterType === filter_type_1.FilterType.LESS_THAN) {
                    var valueTo = filterElement ? filterElement.valueTo : null;
                    criterion = new measure_criterion_money_range_1.MeasureCriterionMoneyRange(filterItem, isNot, false, range_bounding_1.RangeBounding.UPPER, null, criterion_helper_1.CriterionHelper.ifNumber(valueTo), byCategoryItemId, currencyId);
                }
                else if (filterType === filter_type_1.FilterType.LESS_THAN_OR_EQUALS) {
                    var valueTo = filterElement ? filterElement.valueTo : null;
                    criterion = new measure_criterion_money_range_1.MeasureCriterionMoneyRange(filterItem, isNot, true, range_bounding_1.RangeBounding.UPPER, null, criterion_helper_1.CriterionHelper.ifNumber(valueTo), byCategoryItemId, currencyId);
                }
                else if (filterType === filter_type_1.FilterType.GREATER_THAN) {
                    var valueFrom = filterElement ? filterElement.valueFrom : null;
                    criterion = new measure_criterion_money_range_1.MeasureCriterionMoneyRange(filterItem, isNot, false, range_bounding_1.RangeBounding.LOWER, criterion_helper_1.CriterionHelper.ifNumber(valueFrom), null, byCategoryItemId, currencyId);
                }
                else if (filterType === filter_type_1.FilterType.GREATER_THAN_OR_EQUALS) {
                    var valueFrom = filterElement ? filterElement.valueFrom : null;
                    criterion = new measure_criterion_money_range_1.MeasureCriterionMoneyRange(filterItem, isNot, true, range_bounding_1.RangeBounding.LOWER, criterion_helper_1.CriterionHelper.ifNumber(valueFrom), null, byCategoryItemId, currencyId);
                }
            }
            else if (measureType === measure_type_1.MeasureType.BOOLEAN) {
                var value = filterElement ? filterElement.value : null;
                criterion = new criterion_number_1.CriterionNumber(filterItem, isNot, criterion_helper_1.CriterionHelper.ifNumber(value));
            }
            if (!criterion) {
                throw new Error("Unhandled combination of measure and filter types (were '" + measure_type_1.MeasureType[measureType] + "' and '" + filter_type_1.FilterType[filterType] + "' respectively).");
            }
        }
        if (!criterion) {
            throw new Error("Unhandled item type (was '" + item.constructor.name + "').");
        }
        return criterion;
    };
    return FilterHelper;
}());
exports.FilterHelper = FilterHelper;
//# sourceMappingURL=filter-helper.js.map